// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1_6iT","title":"Info_title__10SW5","links":"Info_links__2hGBs","link":"Info_link__hqUiD","logo":"Info_logo__1O4tJ"};